// extracted by mini-css-extract-plugin
export default {"philosophy-text-container":"philosophy_philosophy-text-container__bajOD","philosophy-image-container":"philosophy_philosophy-image-container__QS14S"};